export default "__VITE_ASSET__3F8sOtUB__"